<template>
  <div class="homicides-container">
    <span class="homicides-label">
      Homicides per police district in {{ year }}
    </span>
    <chartist
      ratio="ct-major-second"
      type="Bar"
      :data="districtData"
      :options="districtOptions"
    />
    <ul class="legend-list">
      <li
        v-for="(label, i) in districtLabels"
        :key="label"
        :class="legendClass(i)"
      >{{ label }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "DistrictChart",
  props: {
    allVictims: Array,
    year: String
  },
  data() {
    return {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      districtNames: [
        ["CD", "Central"],
        ["ED", "Eastern"],
        ["ND", "Northern"],
        ["NE", "Northeastern"],
        ["NW", "Northwestern"],
        ["SD", "Southern"],
        ["SE", "Southeastern"],
        ["SW", "Southwestern"],
        ["WD", "Western"]
      ]
    };
  },
  methods: {
    legendClass(i) {
      let className = `legend-${i}`;
      return {
        [className]: true
      };
    }
  },
  computed: {
    districtOptions() {
      return {
        distributeSeries: true,
        axisX: { showGrid: false },
        axisY: {
          low: 0,
          referenceValue: 70,
          onlyInteger: true
        }
      };
    },
    districtAbbrs() {
      return this.districtNames.map(([abbr]) => abbr);
    },
    districtData() {
      let totals = {};
      this.districtAbbrs.forEach(abbr => {
        totals[abbr] = 0;
      });
      this.allVictims.forEach(victim => {
        if (victim.year === this.year) {
          totals[victim.district] += 1;
        }
      });
      let labels = this.districtNames.map(([abbr]) => {
        let total = totals[abbr];
        return `${abbr}\n${total}`;
      });
      let series = this.districtNames.map(([abbr]) => totals[abbr] || 0);
      return {
        labels,
        series
      };
    },
    districtLabels() {
      return this.districtNames.map(([, label]) => label);
    }
  }
};
</script>

<style lang="scss">
</style>
